import React from 'react';
import { motion } from 'framer-motion';
import { Train, ShoppingBag, Trophy, Building, UtensilsCrossed } from 'lucide-react';
export function LocationSection() {
  const highlights = [{
    icon: <Train size={16} data-id="element-66" />,
    text: 'Richmond Station',
    detail: '5 min walk'
  }, {
    icon: <ShoppingBag size={16} data-id="element-67" />,
    text: 'Bridge Road Shopping',
    detail: '2 min walk'
  }, {
    icon: <Trophy size={16} data-id="element-68" />,
    text: 'MCG & Sports Precinct',
    detail: '10 min walk'
  }, {
    icon: <Building size={16} data-id="element-69" />,
    text: 'Melbourne CBD',
    detail: '3 km'
  }, {
    icon: <UtensilsCrossed size={16} data-id="element-70" />,
    text: 'Victoria Street Dining',
    detail: '5 min walk'
  }];
  return <section id="location" className="py-24 md:py-32 bg-brand-black overflow-hidden" data-id="element-71">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-72">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center" data-id="element-73">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-74">
            <h2 className="font-heading text-5xl md:text-6xl text-white mb-6 uppercase" data-id="element-75">
              Richmond, Melbourne
            </h2>
            <div className="w-12 h-0.5 bg-brand-gold mb-8" data-id="element-76"></div>

            <p className="text-brand-muted text-base font-light leading-relaxed mb-10" data-id="element-77">
              Positioned in one of Melbourne's most vibrant and culturally rich
              suburbs, 11 Northcote Street offers unparalleled access to premium
              lifestyle amenities and essential transport infrastructure.
              Richmond is the undisputed capital of inner-city commercial
              enterprise.
            </p>

            <div className="space-y-0 border-t border-white/5" data-id="element-78">
              {highlights.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.08 + 0.3,
              duration: 0.5
            }} className="flex items-center justify-between py-4 border-b border-white/5 group" data-id="element-79">
                  <div className="flex items-center gap-3" data-id="element-80">
                    <span className="text-brand-gold" data-id="element-81">{item.icon}</span>
                    <span className="text-white text-sm font-light" data-id="element-82">
                      {item.text}
                    </span>
                  </div>
                  <span className="text-brand-gold text-sm font-medium tracking-wide" data-id="element-83">
                    {item.detail}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1.2,
          ease: [0.16, 1, 0.3, 1]
        }} className="relative h-[500px] lg:h-[600px] w-full" data-id="element-84">
            <div className="absolute -top-3 -right-3 w-20 h-20 border-t border-r border-brand-gold/40" data-id="element-85"></div>
            <div className="absolute -bottom-3 -left-3 w-20 h-20 border-b border-l border-brand-gold/40" data-id="element-86"></div>

            <div className="relative w-full h-full overflow-hidden bg-brand-surface" data-id="element-87">
              <img src="https://cdn.magicpatterns.com/uploads/vzvx3miBPTm73FBBxvJKNZ/image10.jpg" alt="Aerial view of Richmond showing proximity to Melbourne CBD" className="w-full h-full object-cover" data-id="element-88" />
              <div className="absolute inset-0 bg-brand-black/5" data-id="element-89"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}